const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid md:grid-cols-3 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Cafe Sales Experts</h3>
                        <p className="text-gray-400 text-sm leading-relaxed">
                            Australia&apos;s specialist business brokers for café sales. 
                            We help café owners sell their businesses efficiently and effectively.
                        </p>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
                        <div className="space-y-2 text-gray-400 text-sm">
                            <p>
                                <a href="tel:1800370240" className="hover:text-white transition-colors">
                                    1800 370240
                                </a>
                            </p>
                            <p>Australia Wide Cafe Sales</p>
                        </div>
                    </div>

                    {/* Business Hours */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Business Hours</h3>
                        <div className="space-y-1 text-gray-400 text-sm">
                            <p>Monday - Friday: 8:30am - 4:30pm</p>
                            <p>Saturday - Sunday: Closed</p>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500 text-sm">
                    <p>© {currentYear} Cafe Sales Experts - All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
